import { render, staticRenderFns } from "./ExpireAccount.vue?vue&type=template&id=16220809&scoped=true&"
import script from "./ExpireAccount.vue?vue&type=script&lang=js&"
export * from "./ExpireAccount.vue?vue&type=script&lang=js&"
import style0 from "./ExpireAccount.vue?vue&type=style&index=0&id=16220809&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16220809",
  null
  
)

component.options.__file = "ExpireAccount.vue"
export default component.exports